import React from 'react'
import { render } from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import { Provider } from 'react-redux'

import Root from './components/Root'
import configureStore from './store/configureStore'
import { appInitialized } from './controllers/init'

// import '../public/favicon.ico'
import './styles/polaris.css'

export const store = configureStore()

window.logTiming = () => null

const rootElement = document.getElementById('root')
const appRender = (Component) => {
  render(
    <AppContainer>
      <Provider store={store} >
        <Component />
      </Provider>
    </AppContainer>,
    rootElement
  )
}

preventAccedentalDragNDrop()
appRender(Root)

if (module.hot) {
  module.hot.accept('./components/Root', () => {
    const RootContainer = require('./components/Root').default
    appRender(RootContainer)
  })
}

store.dispatch(appInitialized())

function preventAccedentalDragNDrop () {
  const preventDefault = (e) => {
    e = e || event
    e.preventDefault()
  }

  window.addEventListener('dragover', preventDefault, false)
  window.addEventListener('drop', preventDefault, false)
}



// WEBPACK FOOTER //
// ./src/index.js